<template>
  <div :class="preflxCls">
    <z-dialog
      :title="title"
      @close="closeDialog"
      @submit="submit('projectFrom')"
      @delete="deleteHandle"
      @projectSwitch="projectSwitchHandle"
    >
      <Form
        ref="projectFrom"
        :model="projectFrom"
        :rules="ruleInProject"
        label-position="top"
      >
        <FormItem prop="name" label="项目名称:">
          <Input
            :maxlength="20"
            v-model="projectFrom.name"
            placeholder="请输入项目名称"
          />
        </FormItem>
        <FormItem prop="locationId" :label="'项目所在地:'">
          <z-address
            v-model="projectFrom.locationId"
            :address="address"
            second
          ></z-address>
        </FormItem>
        <FormItem
          v-if="(bookInfo && bookInfo.length > 0) || projectDetail"
          prop="companyAuthId"
          :label="
            projectDetail && projectDetail.type === 2
              ? '公司名称:'
              : '项目类型:'
          "
          class="from-gray"
        >
          <span
            class="insert-span-company"
            v-if="projectDetail && projectDetail.type === 2"
            >{{ projectDetail.companyName }}</span
          >
          <Select
            v-else
            v-model="projectFrom.companyAuthId"
            @on-change="selecProjectHandle"
            :disabled="projectDetail && projectDetail.type === 2 ? true : false"
            style="width:100%"
          >
            <Option
              v-for="item in bookInfo"
              :value="item.authId"
              :key="item.authId"
              >{{ item.authName }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          v-if="
            bookInfo &&
              bookInfo.length === 1 &&
              (bookInfo[0].isNull || bookInfo[0].type === 1)
          "
          prop="companyAuthId"
          class="from-gray"
        >
          <a
            :href="
              `${VUE_APP_OLD_BASIC_URL}/my/personal/accountSetting?index=1`
            "
          >
            <span class="reject-link">企业项目支持团队操作，快去认证企业</span>
          </a>
        </FormItem>
        <FormItem class="from-gray" v-if="blance && blance > 0">
          <span class="reject-link-te">需要消耗 {{ blance }} 颗恐龙蛋</span>
        </FormItem>
        <FormItem label="项目描述:" v-if="projectDetail">
          <Input
            v-model="projectFrom.remark"
            type="textarea"
            :maxlength="200"
            :autosize="{ minRows: 3, maxRows: 3 }"
            placeholder="请输入项目描述（200字以内）"
          ></Input>
        </FormItem>
      </Form>
    </z-dialog>
  </div>
</template>
<script>
const preflxCls = 'zProjectlog'
import { findComponentDownward } from '../../utils/assist.js'
import ZDialog from './dialog'
import ZAddress from '../address/address'
import { filter } from 'minimatch'
export default {
  name: 'ZProjectlog',
  provide() {
    return {
      app: this,
    }
  },
  data() {
    return {
      preflxCls: preflxCls,
      diaologDom: null,
      projectFrom: {
        name: '',
        locationId: 3412,
        companyAuthId: '',
        type: '',
        isOpen: 1,
        remark: '',
      },
      ruleInProject: {
        name: [{ required: true, message: '请输入项目名称' }],
        locationId: [{ required: true, message: '请选择项目所在地' }],
        companyAuthId: [{ required: true, message: '请选择项目属性' }],
      },
    }
  },
  props: {
    /* old */
    VUE_APP_OLD_BASIC_URL: {
      type: String,
      default: 'https://b.zhulogic.com/pass',
    },
    /* 弹框权限 */
    permission: {
      type: [Object, String],
      default: '',
    },
    /* 用户认证或者认证公司列表 */
    bookInfo: {
      type: [Array, String],
      default: function() {
        return []
      },
    },
    /* 判断是否从 组件/页面 传递过来的 数据*/
    projectDetail: {
      type: [Object, String],
      default: function() {
        return ''
      },
    },
    address: {
      type: Array,
      default: function() {
        return []
      },
    },
    display: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '暂无标题',
    },
    width: {
      type: [Number, String],
      default: 360,
    },
    // button text
    btnTxt: {
      type: [Number, String],
      default: '确定',
    },
    // 是否是长按钮
    long: {
      type: Boolean,
      default: false,
    },
    // 是否需要取消
    cel: {
      type: Boolean,
      default: true,
    },
    className: {
      type: String,
      default: 'zhulogicModule',
    },
    // 需要消耗的恐龙蛋数量
    blance: {
      type: [String, Number],
      default: 0,
    },
  },
  components: { ZDialog, ZAddress },

  mounted() {
    const Dialog = findComponentDownward(this, 'ZDialog')
    if (Dialog) {
      this.diaologDom = Dialog
    }
  },

  methods: {
    closeDialog() {
      this.$emit('close')
    },
    submit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('submitHandle', this.projectFrom)
        } else {
          this.$Message.warning('填写完整各项！')
        }
      })
    },
    /* 删除项目 */
    deleteHandle() {
      this.$emit('delete')
    },

    /* 项目开关 */
    projectSwitchHandle() {
      this.$emit('projectSwitch')
    },

    /* 选择项目公司 */
    selecProjectHandle(val) {
      if (!this.bookInfo || this.bookInfo.length === 0) return false
      let item = this.bookInfo.filter((item) => item.authId === val)[0]
      if (item) {
        this.projectFrom.type = item.type
      }
    },
  },
  watch: {
    display: function() {
      if (!this.display) {
        !this.projectDetail && this.$refs['projectFrom'].resetFields()
        this.diaologDom.close()
      } else {
        this.diaologDom.op()
        if (!this.projectDetail) {
          this.projectFrom.companyAuthId =
            this.bookInfo && this.bookInfo[0] && this.bookInfo[0].authId
          this.projectFrom.type = 1
        } else {
          if (this.projectDetail && !this.projectDetail.companyAuthId) {
            if (this.bookInfo && this.bookInfo[0]) {
              this.projectFrom.companyAuthId =
                this.bookInfo && this.bookInfo[0].authId
            }
          }
        }
      }
    },

    projectDetail: function() {
      if (this.projectDetail) {
        Object.assign(this.projectFrom, this.projectDetail)
        // this.projectFrom.type = this.projectDetail.type;
      }
    },

    bookInfo: function() {
      if (!this.bookInfo || this.bookInfo.length === 0) {
        let newObj = {
          authId: 1,
          authName: '个人项目',
          id: 19,
          type: 1,
          isNull: true,
          userId: null,
        }
        this.bookInfo.push(newObj)
      }
      if (
        this.bookInfo &&
        this.bookInfo.length === 1 &&
        this.bookInfo[0].type === 2
      ) {
        let newObj = {
          authId: 1,
          authName: '个人项目',
          id: 19,
          type: 1,
          isNull: true,
          userId: null,
        }
        this.bookInfo.unshift(newObj)

        this.projectFrom.type = 1
        this.projectFrom.companyAuthId =
          this.bookInfo && this.bookInfo[0] && this.bookInfo[0].authId
      }
    },
  },

  created() {
    if (this.projectDetail) {
      Object.assign(this.projectFrom, this.projectDetail)
      this.projectFrom.locationId = this.projectDetail.locationId
    }
  },
}
</script>
